import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axiosInstance";
import Header from "../../Components/PublicHeader";
import Footer from "../../Components/Footer";

const ActivateAccount = () => {
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");

        if (!token) {
            setError("Activation token not found in URL.");
            return;
        }

        const activate = async () => {
            try {
                const res = await axios.post<{ message: string }>("/api/activate", { token });
                setMessage(res.data.message || "Account activated successfully!");
                setTimeout(() => navigate("/login"), 4000);
            } catch (err: any) {
                console.error("Activation failed:", err);
                setError(err.response?.data?.error || "Activation failed. Please try again.");
            }
        };

        activate();
    }, [navigate]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex flex-col">
            <Header />

            <main className="flex-1 flex items-center justify-center px-6 py-10">
                <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-md text-center">
                    <h2 className="text-2xl font-bold text-blue-700 mb-4">🔐 Account Activation</h2>

                    {message && <p className="text-green-600 text-sm">{message}</p>}
                    {error && <p className="text-red-600 text-sm">{error}</p>}
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default ActivateAccount;
